import { useMemo } from "react";
import * as yup from "yup";
import { useTypedTranslation } from "../../hooks";

export type ChangeContributionFormValues = {
    newContributionTextField: number;
    newContributionSliderField: number;
    employerContributes: boolean;
};

export const changeContributionFormDefaultValues: ChangeContributionFormValues = {
    newContributionTextField: 100,
    newContributionSliderField: 100,
    employerContributes: false,
};

export const useChangeContributionSchema = () => {
    const { t } = useTypedTranslation();

    return useMemo(
        () =>
            yup.object().shape({
                //do not validate text field separately, only slider (they are synced)
                newContributionTextField: yup
                    .number()
                    .transform((value) => (isNaN(value) ? undefined : value))
                    .required(),
                newContributionSliderField: yup
                    .number()
                    .transform((value) => (isNaN(value) ? undefined : value))
                    .min(100, t("employerContributionDialog.min100CZK"))
                    .max(10000, t("employerContributionDialog.max10000CZK"))
                    .required(),
                employerContributes: yup.boolean().oneOf([true, false]).required(),
            }),
        [t],
    );
};
